<template>
    <mm-select :options="options"
    v-bind="$attrs" :value="value" v-on="$listeners" />
</template>

<script>
export default {
	data(){
		const options = [
			['adv_id','Adverister'],
			['networkid','Channel'],
			['offerid','Offer'],
			['sub_channel','Sub Channel'],
			['adv_offer_id','Adv. Offer ID'],
			['package_id','Offer PackageId'],
			['aff_sub5','App Name'],
			['aff_sub3','App Id'],
			['country','Region'],
			['os','Platform'],
			['type','Cheat'],
			['traffic_type','Server Click'],
			['event_name','Event Name'],
			['event_value','Event Value'],
		].map(v => {
			return { value: v[0], label: v[1] };
		});
		return{
			options,
		}
	},
	props:['value'],
}
</script>

